<template>
  <LayoutAuth>
    <b-form class="auth__form" @submit.prevent="login">
      <div class="auth__heading">
        <h1 class="auth__title title-h1">
          {{ $metaInfo.title }}
        </h1>
      </div>
      <div class="auth__body">
        <div class="form-row">
          <div class="form-group col-sm-12" :class="{ 'form-group--invalid': $v.username.$error }">
            <Input
              v-model="username"
              color="gray"
              :label="$t(`Email or phone`)"
              :placeholder="$t(`Email or phone`)"
              :error="$v.username.$dirty && !$v.username.required"
              :error-message="$t('Field is required')"
            />
          </div>
        </div>
        <div class="form-row">
          <div class="form-group form-group--password col-sm-12" :class="{ 'form-group--invalid': $v.password.$error }">
            <Input
              v-model="password"
              :label="$t(`Password`)"
              :placeholder="$t(`Password`)"
              type="password"
              :error="$v.password.$dirty && !$v.password.required"
              :error-message="$t('Field is required')"
            />
          </div>
        </div>
      </div>
      <div class="auth__save">
        <Checkbox v-model="rememberMe" class="auth__checkbox" :label="$t('Remember me')" />
        <router-link class="auth__link" :to="{ name: 'resetPassword' }">
          {{ $t('Forgot password?') }}
        </router-link>
      </div>
      <div class="form-row">
        <div class="form-group form-group--button col-sm-12">
          <button class="auth__btn btn-new" type="submit" :disabled="isSending">
            {{ $t('Login') }}
          </button>
        </div>
      </div>
      <span class="auth__promt">* – {{ $t('Fields are required to be completed') }} </span>
      <div class="auth__footer">
        <span>{{ $t(`Don't have an account?`) }}</span>
        <button type="button" class="auth__nav-link" @click="goToRegister">
          {{ $t('Register') }}
          <img class="select-field__icon" src="@/assets/images/icons/select.svg" alt="" />
        </button>
      </div>
    </b-form>
  </LayoutAuth>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { eventBus } from '@/helpers/eventBus'
import { mapFields } from 'vuex-map-fields'
// import VueRecaptcha from 'vue-recaptcha'
import { RECAPTCHA_SITE_KEY } from '@/constants'
import Checkbox from '@/components/form/CheckboxNew.vue'
import Input from '@/components/form/InputNew.vue'
import { sendMetrics } from '@/utils/metrics'
import { sendLocalCartItemsToApi } from '@/helpers/cart/sendLocalCartItemsToApi'

export default {
  components: {
    Checkbox,
    Input,
  },
  data: () => ({
    username: '',
    password: '',
    RECAPTCHA_SITE_KEY,
    isSending: false,
  }),
  computed: {
    ...mapFields('auth', ['rememberMe']),
  },
  methods: {
    async login() {
      if (this.isSending) return

      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      this.isSending = true
      try {
        const { username, password } = this
        await this.$store.dispatch('auth/login', { username, password })
        await this.$store.dispatch('user/loadCurrentUser')
        sendLocalCartItemsToApi()

        this.$router.push({
          path: this.$route.query.redirect || '/',
        })
      } catch (e) {
        if (e.detail === 'Пользователь не верифицирован') {
          eventBus.$emit('error', this.$t('Your access is restricted. Please contact support'))
        } else {
          eventBus.$emit('error', this.$t(e.detail || e))
        }
      } finally {
        this.isSending = false
      }
    },
    goToRegister() {
      sendMetrics('click_register_at_login_screen')
      this.$router.push({ name: 'registerBuyer' })
    },
  },
  validations: {
    username: { required },
    password: { required },
  },
  metaInfo() {
    return { title: this.$t('login.title') }
  },
}
</script>

<style lang="scss" scoped>
@import '~bootstrap/scss/functions';
@import '@/assets/scss/config';
@import '@/assets/scss/mixins';
@import '~bootstrap/scss/variables';
@import '~bootstrap/scss/mixins';

.form {
  background: #ffffff;
  /* Basic */

  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.08);
  border-radius: 32px;
  // .form__body
  &__body {
    position: relative;

    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      visibility: hidden;
      transition: all 0.5s ease 0s;
    }

    &._sending {
      &::after {
        opacity: 1;
        visibility: visible;
      }
    }
  }

  // .form__item
  &__item {
    margin: 0px 0px 20px 0px;
  }

  // .form__label
  &__label {
    display: block;
    margin: 0px 0px 10px 0px;
  }

  // .form__input
  &__input,
  &-control {
    display: block;
    height: 41px;
    padding: 0px 12px;
    border-radius: 5px;
    width: 100%;
    background-color: $LGray3;
    border-color: transparent;
    transition: all 0.5s ease 0s;

    &::placeholder {
      transition: 0.5s ease all 0s;
    }

    &:focus {
      border-color: transparent;
      background-color: $LGray3;
      box-shadow: none;

      &::placeholder {
        opacity: 0;
      }
    }

    &--location {
      position: relative;

      input {
        padding-right: 26px;
      }

      span {
        &::before {
          content: '';
          display: block;
          flex: 0 0 9px;
          width: 9px;
          height: 13px;
          background: url('~@/assets/images/icons/map-marker.svg') no-repeat center/cover;
          position: absolute;
          top: 50%;
          right: 12px;
          transform: translate(0, -50%);
          pointer-events: none;
        }
      }
    }
  }

  // .form__button
  &__button {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 60px;
    background-color: #7a956b;
    color: #fff;
    font-size: 18px;
    text-transform: uppercase;
    letter-spacing: 2px;
    font-weight: 700;
    cursor: pointer;
    border-radius: 20px;
    box-shadow: 0 5px 0 #161b13;
    transition: background-color 0.5s ease 0s;
    position: relative;
    top: 0;

    &:hover {
      background-color: #4f6146;
    }
    &:active {
      top: 3px;
      box-shadow: 0 2px 0 #161b13;
    }
  }

  &-group--phone {
    position: relative;

    span {
      position: absolute;
      top: 50%;
      left: 24px;
      transform: translate(0, -50%);
      pointer-events: none;

      i {
        display: inline-flex;
        font-size: 16px;
        color: $Gray;
      }
    }
  }

  &-control--phone {
    padding-left: 38px;
  }

  &-group--calendar {
    display: flex;
    align-items: center;
    position: relative;

    span {
      display: flex;
      position: absolute;
      @include adaptiv-value('right', 22, 17, 1);
      top: 50%;
      transform: translate(0, -50%);
      pointer-events: none;

      i {
        font-size: 14px;
        color: $Gray;
        display: inline-flex;
        align-items: center;
      }
    }
  }

  &-control--calendar {
    &::-webkit-inner-spin-button,
    &::-webkit-calendar-picker-indicator {
      -webkit-appearance: none;
      opacity: 0;
    }
  }
}

.auth {
  background-color: $LGray4;
  margin: 0 !important;
  height: 100%;

  &__checkbox {
    @include media-breakpoint-down(sm) {
      width: 100%;
    }
  }

  .firstscreen__content {
    @include adaptiv-value('padding-top', 25, 0, 1);

    @include media-breakpoint-down(sm) {
      flex: 0 0 100%;
    }

    @include media-breakpoint-down(xs) {
      margin-bottom: 0;
    }
  }

  &__register-button {
    background-color: transparent;
    border: none;
    padding: 0;
    margin: 0;
    color: $GreenM;
    text-decoration: underline;
  }

  &__form {
    width: 500px;
    margin: 0 auto;
  }

  &__subtitle {
    font-size: 16px;
    line-height: 21px;

    @include media-breakpoint-down(xl) {
      font-size: calc(14px + 2 * ((100vw - #{$layoutMobile}px) / (#{$layoutDesktop} - #{$layoutMobile})));
      line-height: calc(21 / 16);
    }

    a {
      display: inline-block;
      color: $GreenM;
      transition: $transition ease all 0s;
      text-decoration: underline;
    }
  }

  &__link {
    font-weight: 600;
    font-size: 16px;
    line-height: 150%;
    color: #9d9d9d;
    transition: $transition ease all 0s;
  }

  &__save {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    margin-top: 0;
  }

  &__policy {
    font-size: 12px;
    line-height: 15px;
    color: $Gray;
    @include adaptiv-value('margin-top', 36, 24, 1);

    a {
      color: $GreenM;
      transition: $transition ease all 0s;
    }
  }

  .form {
    &-group {
      width: 100%;
      width: 100%;

      &--invalid {
        .form-control {
          border-color: $Red;
        }

        .form-error {
          display: block;
        }
      }

      &--valid {
        .form-control {
          border-color: $GreenM;
        }
      }

      input:-webkit-autofill,
      input:-webkit-autofill:focus {
        transition: background-color 600000s 0s, color 600000s 0s;
      }
    }

    &-control {
      display: block;
      width: 100%;
      height: 41px;
      border-color: $White;
      font-size: 16px;
      line-height: 21px;
      color: $Black;

      &::placeholder {
        color: $Gray;
        transition: $transition ease opacity 0s;
      }

      &:focus {
        box-shadow: none;

        &::placeholder {
          opacity: 0;
        }
      }
    }

    &-error {
      font-size: 10px;
      line-height: 1;
      color: $Red;
      margin: 5px 0;
      display: none;
    }
  }

  .checkbox {
    display: flex;

    &__input {
      &:checked + .checkbox__label::before {
        background-color: $White;
        border-color: $GreenM;
      }
    }

    &__label {
      font-size: 12px;
      line-height: 15px;

      &::before {
        background-color: $White;
        border: 1px solid $White;
      }
      &::after {
        width: 8px;
        height: 7px;
        left: 3px;
        background: url('~@/assets/images/icons/check-green.svg') no-repeat center/cover;
      }
    }
  }

  &__image {
    @include media-breakpoint-down(sm) {
      display: none;
    }
  }
}

.btn-green {
  background-color: #1d9f3a;
  color: #ffffff;
}

// .title-h1 {
//   font-weight: 800;
//   font-size: 38px;
//   line-height: 46px;
// }

.auth__checkbox ::v-deep .checkbox-item__label {
  font-weight: 600;
  font-size: 16px;
  line-height: 150%;
  color: #9d9d9d;
}
</style>
